/* global axios */
import ApiClient from './ApiClient';

class FollowUpsAPI extends ApiClient {
  constructor() {
    super('follow_ups', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  create(payload) {
    return axios.post(this.url, payload);
  }

  update(id, payload) {
    return axios.patch(`${this.url}/${id}`, payload);
  }

  markDone(id) {
    return axios.patch(`${this.url}/${id}/done`);
  }

  cancel(id) {
    return axios.patch(`${this.url}/${id}/cancel`);
  }
}

export default new FollowUpsAPI();
